export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/admin-6e19d3af1129d53cfc91fe7bc6083cc8.jpg";